import { render, staticRenderFns } from "./BalanceRibbonFeedback.vue?vue&type=template&id=de23c3a0&"
import script from "./BalanceRibbonFeedback.vue?vue&type=script&lang=js&"
export * from "./BalanceRibbonFeedback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports